import { EmptyFieldValue } from '@/components/common/item-field-value/EmptyFieldValue';
import { Field } from '@/components/common/item-field-value/Field';
import { formatCurrency, getCurrencySymbol } from '@/lib/utils/common/formatCurrency';
import { NumericField } from './NumericField';

export const CurrencyField = ({
  id,
  name,
  value,
  currencyUnit,
  isEditable = false,
  onChange,
  isPending,
  isSuccess,
  isError,
  error,
  autoFocus = false,
}: {
  id: string;
  name: string;
  value?: number;
  currencyUnit: string | null;
  isEditable?: boolean;
  onChange?: (value: number) => void;
  isPending?: boolean;
  isSuccess?: boolean;
  isError?: boolean;
  error?: Error | null;
  autoFocus?: boolean;
}) => {
  const inputId = `currency-field-${id}`;
  const currencySymbol = getCurrencySymbol(currencyUnit);

  if (!isEditable) {
    return (
      <Field inputId={inputId} name={name}>
        <div className="text-sm text-text-neutral-primary" data-testid="currency-field-value">
          {value === undefined ? <EmptyFieldValue /> : formatCurrency(value ?? 0, currencyUnit)}
        </div>
      </Field>
    );
  }

  return (
    <NumericField
      id={id}
      name={name}
      value={value}
      isEditable={isEditable}
      onChange={onChange}
      isPending={isPending}
      isSuccess={isSuccess}
      isError={isError}
      error={error}
      prefix={currencySymbol}
      autoFocus={autoFocus}
    />
  );
};
